import React from 'react';
import {
  Box, Typography, useTheme,
} from '@mui/material';
import CreditCardOffOutlinedIcon from '@mui/icons-material/CreditCardOffOutlined';

type NoActiveLoansBannerProps = {
  firstName?: string;
};

export default function NoActiveLoansBanner({ firstName }: NoActiveLoansBannerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: 5,
        border: `1.5px solid ${theme.palette.secondary.main}20`,
        background: `${theme.palette.white.main}90`,
        paddingBlock: { xs: 7.5, md: 15 },
        paddingInline: { xs: 5, md: 12 },
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box sx={{
        display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 1.5, sm: 3 }, width: '100%',
      }}
      >

        <Box sx={{
          display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0,
        }}
        >
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: 40, md: 52 },
              height: { xs: 40, md: 52 },
              borderRadius: '12px',
              bgcolor: `${theme.palette.secondary.main}25`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CreditCardOffOutlinedIcon
              sx={{ fontSize: { xs: 20, md: 26 }, color: theme.palette.secondary.main }}
            />
          </Box>

          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: 18, md: 22 },
              fontWeight: 800,
              lineHeight: 1.15,
              color: theme.palette.primary.main,
              display: { xs: 'block', sm: 'none' },
            }}
          >
            Hola
            {firstName && <span>{` ${firstName}`}</span>}
            <span>, no tienes créditos activos</span>
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="h5"
            sx={{
              fontSize: { xs: 18, md: 22 },
              fontWeight: 800,
              lineHeight: 1.15,
              color: theme.palette.primary.main,
              mb: 0.5,
              display: { xs: 'none', sm: 'block' },
            }}
          >
            Hola
            {firstName && <span>{` ${firstName}`}</span>}
            <span>, no tienes créditos activos</span>
          </Typography>

          <Typography
            variant="body2"
            sx={{ lineHeight: { xs: 1.1, md: 1.5 }, marginTop: { xs: 1, md: 0 } }}
          >
            Aquí aparecerán tus créditos cuando tengas uno activo con nosotros.
            Mientras tanto, explora los productos disponibles para ti.
          </Typography>
        </Box>

      </Box>
    </Box>
  );
}

NoActiveLoansBanner.defaultProps = {
  firstName: undefined,
};
